import { render } from "./funcItemC.vue?vue&type=template&id=735dbbe8&ts=true"
import script from "./funcItemC.vue?vue&type=script&lang=ts"
export * from "./funcItemC.vue?vue&type=script&lang=ts"

import "./funcItemC.vue?vue&type=style&index=0&id=735dbbe8&lang=scss&scope=this%20api%20replaced%20by%20slot-scope%20in%202.5.0%2B"

import exportComponent from "E:\\xiangqukejidaima\\米优时官网\\miyoushi-web (3)\\miyoushi-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__